/* Beosync editorial PDP: real-deadline countdown, UGC carousel arrows and tap-to-play clips. */
(() => {
  const pad = (n) => String(n).padStart(2, '0');

  // Counts down to a fixed end time; hides the bar once it has passed. Never resets.
  document.querySelectorAll('[data-bsx-ed-countdown]').forEach((bar) => {
    const end = Date.parse(bar.dataset.end || '');
    const clock = bar.querySelector('.bsx-ed-bar__clock');
    if (!end || !clock) return;
    const parts = clock.querySelectorAll('b');
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) {
        bar.hidden = true;
        return false;
      }
      const s = Math.floor(left / 1000);
      const days = Math.floor(s / 86400);
      const hrs = Math.floor((s % 86400) / 3600) + days * 24;
      parts[0].textContent = pad(hrs);
      parts[1].textContent = pad(Math.floor((s % 3600) / 60));
      parts[2].textContent = pad(s % 60);
      return true;
    };
    if (tick()) {
      clock.hidden = false;
      const id = setInterval(() => { if (!tick()) clearInterval(id); }, 1000);
    }
  });

  document.querySelectorAll('[data-bsx-ed-carousel]').forEach((root) => {
    const track = root.querySelector('.bsx-ed-ugc__track');
    const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 12 : 300);
    root.querySelector('[data-dir="prev"]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    root.querySelector('[data-dir="next"]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  // Tap-to-play customer clips: one plays at a time, with sound and native controls.
  const clips = [...document.querySelectorAll('[data-bsx-ed-clip]')];
  clips.forEach((clip) => {
    const video = clip.querySelector('video');
    const play = clip.querySelector('.bsx-ed-ugc__play');
    if (!video || !play) return;
    play.addEventListener('click', () => {
      clips.forEach((other) => {
        const v = other.querySelector('video');
        if (other !== clip && v && !v.paused) v.pause();
      });
      clip.classList.add('is-playing');
      video.controls = true;
      video.muted = false;
      video.play();
    });
    video.addEventListener('ended', () => {
      clip.classList.remove('is-playing');
      video.controls = false;
    });
  });
})();
